import { useState } from "react";
import styled from "styled-components";
import {
  Button,
  ContentBox,
  ContentPage,
  NoResults,
  Notice,
  PageActions,
  SelectorPageStatus,
} from "@ficatranquilo/contabilidade.com-ui";
import { usePageHeader } from "@components/ow";
import { canSendAnonymous } from "@helpers/declarations";
import { DeclarationViewModal, DeclarationsTable, declarationColumns } from "../../Common/Declarations";
import NewDeclarationModal from "./NewDeclarationModal";

// Declarações do prestador (modelo Lista com abas): as que ele enviou (`myList=1`)
// e as da empresa toda, que todo colaborador vê (a anônima sem o autor).

const BREADCRUMB = [{ page: "Declarações", route: "/e/declarations" }];

const TABS = [
  { label: "Minhas declarações", value: "mine" },
  { label: "Da empresa", value: "company" },
];

const COLUMNS = { mine: declarationColumns({ own: true }), company: declarationColumns() };

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export default function DeclarationsEmployee() {
  const user = JSON.parse(localStorage.getItem("user_ow") || "null");
  const allowAnonymous = canSendAnonymous(user);
  const [tab, setTab] = useState(TABS[0]);
  const [creating, setCreating] = useState(false);
  const [viewing, setViewing] = useState(null);
  // Muda depois de um envio, para a lista voltar à primeira página com a nova
  const [reload, setReload] = useState(0);

  usePageHeader({ title: "Declarações", breadcrumb: BREADCRUMB });

  const mine = tab.value === "mine";
  const openCreate = () => setCreating(true);

  function afterSend() {
    setCreating(false);
    setTab(TABS[0]);
    setReload((n) => n + 1);
  }

  return (
    <ContentPage>
      <PageActions>
        <Button $text="Nova declaração" $variant="primary" $action={openCreate} />
      </PageActions>

      <ContentBox>
        <Stack>
          <Notice
            $variant="gray"
            $text={
              allowAnonymous
                ? "A empresa e os colegas veem as declarações em Declarações. Nas anônimas, ninguém vê quem enviou."
                : "A empresa e os colegas veem as declarações em Declarações, com o seu nome."
            }
          />
          <SelectorPageStatus $variant="segmented" options={TABS} selected={tab} onChange={setTab} />
          <DeclarationsTable
            key={`${tab.value}#${reload}`}
            query={mine ? "myList=1" : ""}
            columns={COLUMNS[tab.value]}
            onOpen={setViewing}
            noResults={
              <NoResults
                notResultText={mine ? "Você ainda não enviou declarações" : "Nenhuma declaração por aqui"}
                includeText="Nova declaração"
                includeAction={openCreate}
              />
            }
          />
        </Stack>
      </ContentBox>

      {creating ? (
        <NewDeclarationModal user={user} allowAnonymous={allowAnonymous} onClose={() => setCreating(false)} onSent={afterSend} />
      ) : null}
      {viewing ? <DeclarationViewModal declaration={viewing} own={mine} onClose={() => setViewing(null)} /> : null}
    </ContentPage>
  );
}
